import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import AppsIcon from '@material-ui/icons/Apps';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ViewListIcon from '@material-ui/icons/ViewList';
import TimelineIcon from '@material-ui/icons/Timeline';
import BubbleChartIcon from '@material-ui/icons/BubbleChart';
import RateReviewIcon from '@material-ui/icons/RateReview';
import AccountCircle from '@material-ui/icons/AccountCircle';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';

import { Link as RouterLink} from 'react-router-dom';

import { useOvermind } from '../../overmind';

function ListItemLink(props) {
  const { disabled, icon, primary, to } = props;

  const renderLink = React.useMemo(
    () => React.forwardRef((itemProps, ref) => <RouterLink to={to} ref={ref} {...itemProps} />),
    [to],
  );

  return (
    <li>
      <ListItem disabled={disabled} button component={renderLink}>
        {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
        <ListItemText primary={primary} />
      </ListItem>
    </li>
  );
}

ListItemLink.propTypes = {
  icon: PropTypes.element,
  primary: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
};


const useStyles = makeStyles({
  root: {
    width: 239,
    height:'91vh'
  },
});

export default function ListRouter() {
  const classes = useStyles();
  const { state } = useOvermind();

  const menuDisabled = () =>{
    if(typeof state.tagDataTable === 'undefined'){
      return true;
    }else{
      return false;
    }
  }
    return (

        <div className={classes.root}>
          <Paper elevation={0}>
            <List aria-label="main mailbox folders">
              <ListItemLink disabled={menuDisabled()} to="/get-started" primary="Get Started" icon={<AppsIcon />} />
              <ListItemLink disabled={menuDisabled()} to="/documentation" primary="Documentation" icon={<ViewListIcon />} />
              <ListItemLink disabled={menuDisabled()} to="/audit" primary="Container Audit" icon={<RateReviewIcon />} />
              <ListItemLink disabled={menuDisabled()} to="/network" primary="Network Visualization" icon={<BubbleChartIcon />} />
              <ListItemLink disabled={menuDisabled()} to="/utilization" primary="Custom JS Utilization" icon={<DashboardIcon />} />
              <ListItemLink disabled={menuDisabled()} to="/history" primary="Release History" icon={<TimelineIcon />} />
            </List>
            <Divider />
            <List aria-label="secondary mailbox folders">
              <ListItemLink to="/config" primary="Account" icon={<AccountCircle />} />
              <ListItemLink to="/contact-us" primary="Contact Us" icon={<ContactSupportIcon />} />
            </List>
          </Paper>
        </div>
    );
  }
